import React, { createContext, useState, useContext, useEffect } from "react";

const LoadingContext = createContext();

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [loadingText, setLoadingText] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 400);
    return () => clearTimeout(timer);
  }, []);

  const showLoading = (text = "") => {
    setLoadingText(text);
    setIsLoading(true);
  };

  const hideLoading = () => {
    setTimeout(() => {
      setIsLoading(false);
      setLoadingText(""); // Clear the text when loading ends
    }, 800);
  };

  return (
    <LoadingContext.Provider value={{ isLoading, showLoading, hideLoading, loadingText }}>
      {children}
    </LoadingContext.Provider>
  );
};